import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { SectorDto, SubSectorDto } from '../dtos/sectors.model';

@Injectable()
export class SectorService {
    public sectorAdded: Subject<any>;
    public subSectorAdded: Subject<any>;

    constructor(private apiService: ApiService,
       private router: Router) {
        this.sectorAdded = new Subject<any>();
        this.subSectorAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getSectors(params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        console.log('>>getSectors', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<SectorDto>>('sectors', params);
    }

    /**
     * Returns lookup list of sub sectors
     * @param params
     */
    getSubSectors(params?: any): Observable<ApiResponse<ApiPagedResponse<SubSectorDto>>> {
        console.log('>>getSectors', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<SubSectorDto>>('sectors/sub-sector', params);
    }

    /**
     * Returns Sub Sector
     * @param params
     */
    getSubSector(id): Observable<ApiResponse<SubSectorDto>> {
        return this.apiService.get<SubSectorDto>(`sectors/sub-sector/${id}`, {});
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getSectorRetailers(id: number, params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        console.log('>>getSectorRetailers', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<SectorDto>>(`sectors/retailers/${id}`, params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getSector(id: number, params?: any): Observable<ApiResponse<SectorDto>> {
        console.log('>>getSector', JSON.stringify(params));
        return this.apiService.get<SectorDto>(`sectors/${id}`, params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    saveSector(sector: SectorDto): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`sectors`, sector);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    saveSubSector(sector: SubSectorDto): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`sectors/sub-sector`, sector);
    }

}



// WEBPACK FOOTER //
// ./src/app/client-core/services/sector.service.ts